import { create } from 'zustand';
import { getBookDemoStatusApi } from "@/api/organization";

const reQueryBookDemoStatus = async (email: string, params?: any) => {
  const { andLoading = true } = params || {};

  // 重新进入 置空
  if (andLoading) {
    useBookDemoStatusStore.setState({ isLoadingBookDemoStatus: true });
  }

  useBookDemoStatusStore.setState({ isRequestingBookDemo: true });  // 设置请求标志
  
  getBookDemoStatusApi(email).then((data) => {
    useBookDemoStatusStore.setState({
      bookDemoStatus: data,
      isLoadingBookDemoStatus: false,
      isRequestingBookDemo: false  // 重置请求标志
    });
  }).catch(() => {
    useBookDemoStatusStore.setState({ 
      isLoadingBookDemoStatus: false,
      isRequestingBookDemo: false  // 错误时也要重置标志
    });
  });
}

type BookDemoStatusStore = {
  bookDemoStatus: {
    isDemoBooked: boolean;
    isNotICP: boolean;
  } | null;
  setBookDemoStatus: (data: { isDemoBooked: boolean; isNotICP: boolean } | null) => void;
  isLoadingBookDemoStatus: boolean;
  setIsLoadingBookDemoStatus: (data: boolean) => void;
  reQueryBookDemoStatus: (email: string, params?: any) => void;
  isRequestingBookDemo: boolean;
};

export const useBookDemoStatusStore = create<BookDemoStatusStore>((set, get) => ({
  bookDemoStatus: null,
  setBookDemoStatus: (bookDemoStatus) => set({ bookDemoStatus }),
  isLoadingBookDemoStatus: false,
  setIsLoadingBookDemoStatus: (isLoadingBookDemoStatus: boolean) => set({ isLoadingBookDemoStatus }),
  reQueryBookDemoStatus,
  isRequestingBookDemo: false,
}));

// 便捷的hook，用于在组件中直接使用
export const useBookDemoStatus = (email?: string) => {
  const {
    bookDemoStatus,
    isLoadingBookDemoStatus,
    isRequestingBookDemo,
    reQueryBookDemoStatus,
    setBookDemoStatus
  } = useBookDemoStatusStore();

  // 如果提供了email，自动获取数据
  const fetchBookDemoStatus = (userEmail: string) => {
    if (userEmail && !isRequestingBookDemo) {
      reQueryBookDemoStatus(userEmail);
    }
  };

  return {
    isDemoBooked: bookDemoStatus?.isDemoBooked ?? false,
    isNotICP: bookDemoStatus?.isNotICP ?? false,
    isLoading: isLoadingBookDemoStatus,
    isRequesting: isRequestingBookDemo,
    fetchBookDemoStatus,
    setBookDemoStatus,
    bookDemoStatus
  };
};
